<template>
	<div>
		<VueHtml2pdf
			:show-layout="false"
			:float-layout="true"
			:enable-download="false"
			:preview-modal="true"
			:paginate-elements-by-height="1400"
			:filename="filename"
			:pdf-quality="2"
			:manual-pagination="false"
			pdf-format="a4"
			pdf-orientation="portrait"
			pdf-content-width="800px"
			ref="html2Pdf"
			:html-to-pdf-options="options"
		>

		<!-- 
			:html-to-pdf-options="options"
			pdf-content-width="800px"
			:paginate-elements-by-height="1400" -->

			<template slot="pdf-content">
				<v-app>
					<v-main>
						<!-- <div style="margin: 12px 12px"></div> -->
    					<!-- <v-container > -->

						<div class="mx-8">
							<v-avatar size="48px">
								<img :src="logo">
							</v-avatar>
							<span class="ml-4 text-h4">{{ logoTitle }}</span>

							<h2 class="text-center">{{ title }}</h2>

							<v-row no-gutters>
								<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
									№ {{ id }}
								</v-col>
								<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="text-right">
									{{ date | formatDateTime }}
								</v-col>
								<v-col cols="12" class="text-right">
									{{ username }}
								</v-col>
							</v-row>
							<br>
							<hr>
							<br>
						</div>

						<div class="mx-8" v-if="generals.length">
							<v-simple-table dense >
								<template v-slot:default>
									<!-- <thead>
										<tr>
											<th class="text-left">Назва</th>
											<th class="text-left">Значення</th>
										</tr>
									</thead> -->
									<tbody>
										<tr v-for="(item, index) in generals" :key="index">
											<td>{{ item.name }}</td>
											<td>{{ item.value }}</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</div>

						<div class="my-8 mx-8" v-if="estimates.length">
							<h3>Транспортні засоби</h3><br>
							<v-simple-table dense>
								<template v-slot:default>
									<thead>
										<tr>
											<th class="text-left">Назва</th>
											<th class="text-left">Оцінка</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="estimate in estimates" :key="estimate.id">
											<td  width="80%">
												<p v-if="estimate.hasOwnProperty('request')">
													<span v-if="estimate.request.hasOwnProperty('id')"><b>Id: </b><span>{{ estimate.request.id }}</span></span>
													<span v-if="estimate.request.hasOwnProperty('number') && estimate.request.number" class="ml-2"><b>Номер: </b><span>{{ estimate.request.number }}</span></span>
													<span v-if="estimate.request.hasOwnProperty('vin') && estimate.request.vin" class="ml-2"><b>Vin: </b><span>{{ estimate.request.vin }}</span></span>
													<span v-if="(estimate.request.hasOwnProperty('brand') && estimate.request.brand) || (estimate.request.hasOwnProperty('model') && estimate.request.model)" class="ml-2">
														<b>Марка і модель: </b>
														<span v-if="estimate.request.hasOwnProperty('brand') && estimate.request.brand">
															<span v-if="estimate.request.brand.hasOwnProperty('name')">{{ estimate.request.brand.name }}</span>
														</span>
														<span v-if="estimate.request.hasOwnProperty('model') && estimate.request.model">
															<span v-if="estimate.request.model.hasOwnProperty('name')" class="ml-2">{{ estimate.request.model.name }}</span>
														</span>
													</span>
													<span v-if="estimate.request.hasOwnProperty('yearProd') && estimate.request.yearProd" class="ml-2"><b>Рік виробництва: </b><span>{{ estimate.request.yearProd }}</span></span>
													<span v-if="estimate.request.hasOwnProperty('engineVolume') && estimate.request.engineVolume" class="ml-2"><b>Об'єм двигуна: </b><span>{{ estimate.request.engineVolume }}</span></span>
												</p>
											</td>
											<td  width="20%" class="text-right">
												<div v-if="estimate.hasOwnProperty('avgPriceUAH')">{{ estimate.avgPriceUAH | toCurrencyUAH }}</div>
												<div v-if="estimate.hasOwnProperty('avgPriceUSD')">{{ estimate.avgPriceUSD | toCurrencyUSD }}</div>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</div>
					</v-main>	
				</v-app>
			</template>
		</VueHtml2pdf>
	</div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
/*
https://www.npmjs.com/package/vue-html2pdf
*/
export default {
	components: { VueHtml2pdf },
	data () {
		return {
			title: 'Оцінка парку транспортних засобів',
			logo: require('../../assets/logo.svg'),
			logoTitle: 'Ortica Systems',
			
			options: {
				//margin: [10,10,10,10],
				margin: [10,0,10,0],
				filename: `Оцінка парку ТЗ.pdf`,
				image: { type: 'jpeg', quality: 0.98 },
				enableLinks: false,
				html2canvas: { scale: 1, useCORS: true },
				jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
				pagebreak: { avoid: ['tr'] },
			}
		}
	},
	props: {
		item: 		{ type: Object, default: () => {} },
	},

	computed: {
		id() {
			return this.item?.id ? this.item.id: null;
		},

		date() {
			return this.item?.date ? this.item.date : null;
		},

		username() {
			return this.item?.user?.name ? this.item.user.name: '';
		},

		filename() {
			return this.title + ' ' + this.id
		},

		generals() {
			let result = [];

			if(this.item?.code) result.push({ name: 'Код', value: this.item.code})
			if(this.item?.name) result.push({ name: 'Назва', value: this.item.name})
			if(this.item?.description) result.push({ name: 'Опис', value: this.item.description})
			if(this.item?.type?.name) result.push({ name: 'Тип', value: this.item.type.name})
			//if(this.item?.minPriceUAH > 0) result.push({ name: 'Мінімальна ціна, UAH', value: this.$options.filters.toCurrencyUAH(this.item.minPriceUAH)})
			//if(this.item?.minPriceUSD > 0) result.push({ name: 'Мінімальна ціна, USD', value: this.$options.filters.toCurrencyUSD(this.item.minPriceUSD)})
			if(this.item?.avgPriceUAH > 0) result.push({ name: 'Середня ціна, UAH', value: this.$options.filters.toCurrencyUAH(this.item.avgPriceUAH)})
			if(this.item?.avgPriceUSD > 0) result.push({ name: 'Середня ціна, USD', value: this.$options.filters.toCurrencyUSD(this.item.avgPriceUSD)})
			//if(this.item?.maxPriceUAH > 0) result.push({ name: 'Максимальна ціна, UAH', value: this.$options.filters.toCurrencyUAH(this.item.maxPriceUAH)})
			//if(this.item?.maxPriceUSD > 0) result.push({ name: 'Максимальна ціна, USD', value: this.$options.filters.toCurrencyUSD(this.item.maxPriceUSD)})
			if(this.item?.estimates) result.push({ name: 'Кількість оцінок', value: this.item.estimates.length})

			return result
		},

		estimates() {
			return this.item?.estimates ? this.item.estimates: [];
		},
	},

	methods: { 
		/* adverts(items) {
			const sorted = [...items].sort((a, b) => parseInt(a.price) - parseInt(b.price));
			return sorted
		}, */

        generate () {
			//console.log('\\pdf\\VehicleEstimate.vue', 'generate', 'item', this.item)
			this.$refs.html2Pdf.generatePdf()            
        },
    },

}
</script>

<style>
    table.print-friendly tr td, table.print-friendly tr th {
        page-break-inside: avoid;
    }
</style>